import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {forkJoin, Observable, Observer} from 'rxjs';
import * as $ from 'jquery';




@Injectable({
  providedIn: 'root'
})
export class RoutingDemoPageService {
  request: string;
  constructor( private http: HttpClient) { }
  private appBaseUrl: any;
   appEnv: any;
  private fetchTokenURL: any;
  private fetchDBURL: any;
  map: any;
  layerGroup: any;

    init() {
        this.http.get('resources/rjs.json').subscribe((response: any) => {
          if (null !== (response.url)) {
            this.appBaseUrl = response.url;
            this.appEnv = response.env;
          }
        });

        this.http.get('resources/erm.json').subscribe((response: any) => {
          if (null !== (response.url)) {
            this.appBaseUrl = response.url;
            this.appEnv = response.env;
            this.fetchTokenURL = response.fetchTokenURL;
            this.fetchDBURL = response.fetchDBURL;
          }
        });
    }
    getBaseUrl() {
      return this.appBaseUrl;

    }
    getEnv() {
      return this.appEnv;

    }
    getFetchTokenURL() {
      return this.fetchTokenURL;

    }
    getFetchDBURL() {
      return this.fetchDBURL;

    }
    gotoElement(eID) {
      $('html, body').animate({

        scrollTop: $('#' + eID).offset()

      }, 2000);
    }
    executeService(serviceURL, username, password): Observable<any> {
      const headers = {
        Authorization: 'Basic ' + btoa(username + ':' + password),
        'Content-Type': 'application/json;'
      };
      return this.http.get(serviceURL, {headers} );
    }
    executePostService(serviceURL, postData, username, password): Observable<any> {
      const headers = {
          Authorization: 'Basic ' + btoa(username + ':' + password),
          'Content-Type': 'application/json;charset=utf-8;'
        };

      return this.http.post(serviceURL, postData, {headers} );
    }
    getDataRJS(): Observable<any> {
      let result;
      result = this.http.get('resources/rjs.json');
      return forkJoin(result);
    }
    getDataERM(): Observable<any> {
    let result;
    result = this.http.get('resources/erm.json');
    return forkJoin(result);
  }
    serverAndPort(baseURL, url) {
    if (this.appEnv === 'erm') {
      this.request = location.origin + baseURL.substring(2, baseURL.length) + url;
    } else {
      this.request = location.href.replace('/routingDemoPage/' , '') + baseURL.substring(2, baseURL.length) + url;
    }
    return this.request;
  }
}
